<template>
  <div class="component-form-card">
    <div class="form-card-title">
      {{ title }}
    </div>
    <a-form
      style="padding-top: 20px;"
      :form="form"
      :layout="layout"
    >
      <a-row :gutter="gutter">
        <a-col
          v-for="item in formData"
          :key="item.name"
          :span="item.span"
        >
          <a-form-item
            :label="item.lable"
            :colon="false"
            :label-col="{ span: item.lableCol }"
            :wrapper-col="{ span: item.wrapperCol, offset: item.offset }"
          >
            <slot :name="item.name" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
export default {
  props: ['title', 'formData', 'layout', 'gutter'],
  data() {
    return {
      form: this.$form.createForm(this),
    };
  },
};
</script>
<style lang="scss">
.global-card {
  .component-form-card {
    .ant-card-body {
      display: block;
    }
    .form-card-title {
      border-left: 1px solid #46d3dd;
      margin-left: -32px;
      padding-left: 20px;
      font-size: 16px;
      color: #565c66;
    }
  }
}
</style>
